import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {Project} from '@app/modules/shared/models';
import {
  getProject,
  getProjectError,
  getProjectSuccessResponse,
  IProjectState,
  ProjectGet
} from '@app/stores';

@Component({
  selector: 'app-influencer-auto-join',
  templateUrl: './influencer-auto-join.component.html',
  styleUrls: ['./influencer-auto-join.component.scss']
})
export class InfluencerAutoJoinComponent implements OnInit, OnDestroy {
  projectId: number;
  project: Project = null;

  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private projectStore: Store<IProjectState>,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.projectId = Number(this.route.snapshot.paramMap.get('projectId'));
    this.projectStore.pipe(select(getProject), takeUntil(this.destroy$)).subscribe((project) => {
      if (project && Number(project.id) === this.projectId) this.project = project;
    });
    this.projectStore.pipe(select(getProjectSuccessResponse), takeUntil(this.destroy$))
      .subscribe((project) => {
        if (project && Number(project.id) === this.projectId) this.project = project;
      });
    this.projectStore.pipe(select(getProjectError), takeUntil(this.destroy$)).subscribe((error) => {
      if (error) this.toastr.error(error, 'Error');
    });
    this.projectStore.dispatch(ProjectGet({projectId: this.projectId}));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
